var render = function render(){var _vm=this,_c=_vm._self._c;return _c('general-textarea',{ref:"labelSegmentContentDataInput",attrs:{"label":"Label","dense":"","autofocus":"","rows":"1","no-resize":"","disabled":_vm.isImmutable},model:{value:(_vm.$_label),callback:function ($$v) {_vm.$_label=$$v},expression:"$_label"}})
}
var staticRenderFns = []

export { render, staticRenderFns }